require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-trees-as-graphs-vs-trees-as-data-structures.json") })
        }
      }, "path---blog-trees-as-graphs-vs-trees-as-data-structures");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-trees-as-graphs-vs-trees-as-data-structures!./.cache/json/blog-trees-as-graphs-vs-trees-as-data-structures.json
// module id = 1139
// module chunks = 231608221292675